import { useApiDown } from "../../utils/apiStatus";
import "./BackShortlyBanner.css";

export const BACK_SHORTLY_TEXT =
  "We're making a quick update. Emporia will be back in a few minutes. Your cart is saved.";

// Shown on every page while the API is confirmed down (a release holding
// it, src/utils/apiStatus.js), and gone by itself when it answers again.
export default function BackShortlyBanner() {
  const down = useApiDown();
  if (!down) return null;
  return (
    <div className="back-shortly" role="status" aria-live="polite" data-testid="back-shortly">
      <p className="back-shortly-text">{BACK_SHORTLY_TEXT}</p>
    </div>
  );
}
